import styled from 'styled-components'

export const AlertWrapper = styled.div`
  margin-top: 10px;
`
export const ChargeWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
`

export const ChargeRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`
export const ChargeSelect = styled.select`
  background: none;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 10px;
`
